// import JS files
import _ from 'lodash';
import '../kickstart';
import './collapsible-table-rows';
import renderUnemploymentRate from './unemployment-rate';
import renderSalesTaxRevenue from './sales-tax-revenue-yoy';
import data from '../../../data/data.json';

// import react components
import { h, render } from 'preact';
import UnemploymentRateMapGrid from '../components/UnemploymentRateMapGrid';
import MiniRateChange from '../components/MiniRateChange';
import SigUnemploymentRate from '../components/SigUnemploymentRate';
import EmploymentByIndustryGrid from '../components/EmploymentByIndustryGrid';

renderSalesTaxRevenue();
renderUnemploymentRate();

// render all 3 charts
function renderGraphics() {
  renderSalesTaxRevenue();
  renderUnemploymentRate();
}

// sig
// render(
//   <SigUnemploymentRate />,
//   document.getElementById('sig-unemployment-rate')
// );

// employment by industry
render(
  <EmploymentByIndustryGrid />,
  document.getElementById('employment-industry-grid')
);

// mini maps
render(
  <UnemploymentRateMapGrid />,
  document.getElementById('county-unemployment-map-grid')
);

// tables
let rate_over_time = data.unemployment_rate_county_over_time;
let counties = rate_over_time.map(d => d.county);
let oilGasCounties = [
  'Yoakum',
  'Andrews',
  'Shackelford',
  'Loving',
  'Winkler',
  'Ward',
  'Midland',
  'Upton',
  'Reagan',
  'Irion',
  'La Salle',
];
let urbanCounties = ['Dallas', 'Harris', 'Bexar', 'Travis'];

counties.forEach(county => {
  render(
    <MiniRateChange county={county} section="all" />,
    document.getElementById(`rate-change-all-${county.replace(' ', '-')}`)
  );
});

// oilGasCounties.forEach(county => {
//   render(
//     <MiniRateChange county={county} section="oil-gas" />,
//     document.getElementById(`rate-change-oil-gas-${county.replace(' ', '-')}`)
//   );
// });

// urbanCounties.forEach(county => {
//   render(
//     <MiniRateChange county={county} section="urban" />,
//     document.getElementById(`rate-change-urban-${county.replace(' ', '-')}`)
//   );
// });

// add renderGraphics() function to resize event
window.addEventListener('resize', _.debounce(renderGraphics, 200));
